// extracted by mini-css-extract-plugin
module.exports = {"certificate-of-origin":"CertificateOfOrigin_certificate-of-origin__lCOz2","container":"CertificateOfOrigin_container__L_tQP"};